import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { zodSupplierObjectSchema } from '../validations';

/**
 * Zod schema for the GET /suppliers/network query parameters.
 */
export const zodNetworkSuppliersQueryParamsSchema = z.object({
  isRelevant: z.boolean().nullish(),
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().min(0).default(0),
  recipientCompanyIds: z.preprocess(
    (value) => (value === undefined || value === null ? value : [value].flat()),
    z.array(z.uuid()).min(1),
  ),
  searchString: z.string().trim().nullish(),
});

/**
 * Zod schema for a single row in the network supplier catalog
 * (SupplierCardListItem).
 */
export const zodSupplierCardListItemSchema = z.object({
  alreadyRelevant: z.boolean(),
  dataExchangeId: z.uuid().nullish(),
  supplier: zodSupplierObjectSchema,
});

/**
 * Zod schema for the paginated GET /suppliers/network response
 * (SupplierNetworkResponse).
 */
export const zodNetworkSuppliersResponseSchema = z.object({
  data: z.array(zodSupplierCardListItemSchema),
  hasNextPage: z.boolean(),
  limit: z.number().int().min(1).max(500),
  offset: z.number().int().nonnegative(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative(),
});
